<template>
    <div class="article-learn-swing">
        <p class="hidden sm:block">
            <strong>Want to dance like the All-Stars?</strong>
        </p>
        <p>Your journey starts with a beginner class...</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleLearnSwing',
};
</script>
